"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  ArrowLeft1: ['arrow-left-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M16.25,23.25,5.53,12.53a.749.749,0,0,1,0-1.06L16.25.75']],
  ArrowDoubleLeft1: ['arrow-double-left-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M5.211,14.59l6.54,4.162,6.538-4.162c.667-.424,1.711-.08,1.711.565v2.411a1.372,1.372,0,0,1-.7,1.129L12.43,23.064a1.332,1.332,0,0,1-1.358,0L4.2,18.7a1.372,1.372,0,0,1-.7-1.129V15.155C3.5,14.51,4.544,14.166,5.211,14.59Z', 'M5.211,6.187l6.539,4.162,6.539-4.162c.667-.424,1.711-.08,1.711.564V8.522a1.371,1.371,0,0,1-.7,1.129l-6.867,4.37a1.337,1.337,0,0,1-1.358,0L4.2,9.651a1.371,1.371,0,0,1-.7-1.129V6.751C3.5,6.107,4.544,5.763,5.211,6.187Z', 'M4.25 0.75L11.75 6 19.25 0.75']],
  ArrowCornerLeft: ['arrow-corner-left', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M20.16 3.75L4.25 19.66', 'M4.25 4.66L4.25 19.66 19.25 19.66']],
  ArrowButtonUp2: ['arrow-button-up-2', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M11.363,2.626,1.6,19.875A.75.75,0,0,0,2.237,21H21.763a.75.75,0,0,0,.637-1.125L12.637,2.626A.729.729,0,0,0,11.363,2.626Z']],
  ArrowButtonUp3: ['arrow-button-up-3', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M22.031,18.565,12,10.54,1.969,18.565A.75.75,0,0,1,.75,17.979V12.76a1.5,1.5,0,0,1,.563-1.171L11.531,3.414a.752.752,0,0,1,.938,0l10.218,8.175a1.5,1.5,0,0,1,.563,1.171v5.219A.75.75,0,0,1,22.031,18.565Z']],
  ArrowCircleDown: ['arrow-circle-down', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 12.000 A11.250 11.250 0 1 0 23.250 12.000 A11.250 11.250 0 1 0 0.750 12.000 Z', 'M6.75,9l4.617,7.256a.751.751,0,0,0,1.266,0L17.25,9']],
  ArrowCircleLeft: ['arrow-circle-left', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 12.000 A11.250 11.250 0 1 0 23.250 12.000 A11.250 11.250 0 1 0 0.750 12.000 Z', 'M15,6.75,7.744,11.367a.751.751,0,0,0,0,1.266L15,17.25']],
  ArrowCircleUp: ['arrow-circle-up', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 12.000 A11.250 11.250 0 1 0 23.250 12.000 A11.250 11.250 0 1 0 0.750 12.000 Z', 'M17.25,15,12.633,7.744a.751.751,0,0,0-1.266,0L6.75,15']],
  ArrowDotCornerLeft1: ['arrow-dot-corner-left-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M4.821,18.679a.375.375,0,1,1-.53,0,.374.374,0,0,1,.53,0', 'M5.882,14.966a.375.375,0,1,1-.53,0,.377.377,0,0,1,.53,0', 'M8.534,12.315a.375.375,0,1,1-.531,0,.375.375,0,0,1,.531,0', 'M8,7.542a.375.375,0,1,1-.53,0,.374.374,0,0,1,.53,0', 'M5.352,4.89a.375.375,0,1,1-.531,0,.377.377,0,0,1,.531,0', 'M5.352,10.193a.375.375,0,1,1-.531,0,.377.377,0,0,1,.531,0', 'M8.534,17.618a.375.375,0,1,1-.531,0,.375.375,0,0,1,.531,0', 'M11.185,14.966a.375.375,0,1,1-.53,0,.375.375,0,0,1,.53,0', 'M11.185,9.663a.375.375,0,1,1-.53,0,.374.374,0,0,1,.53,0', 'M13.837,12.315a.375.375,0,1,1-.53,0,.375.375,0,0,1,.53,0', 'M13.837,7.011a.375.375,0,1,1-.53,0,.377.377,0,0,1,.53,0', 'M16.489,9.663a.375.375,0,1,1-.531,0,.375.375,0,0,1,.531,0', 'M16.489,4.36a.375.375,0,1,1-.531,0,.375.375,0,0,1,.531,0', 'M19.14,7.011a.375.375,0,1,1-.53,0,.375.375,0,0,1,.53,0', 'M15.958,15.5a.375.375,0,1,1-.53,0,.374.374,0,0,1,.53,0', 'M18.61,18.148a.375.375,0,1,1-.53,0,.377.377,0,0,1,.53,0', 'M13.307,18.148a.375.375,0,1,1-.531,0,.377.377,0,0,1,.531,0']],
  ArrowButtonCircleDown: ['arrow-button-circle-down', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 12.000 A11.250 11.250 0 1 0 23.250 12.000 A11.250 11.250 0 1 0 0.750 12.000 Z', 'M16.818,8.25H7.182c-.55,0-.913.475-.679.888l4.818,8.505a.822.822,0,0,0,1.357,0L17.5,9.138C17.731,8.725,17.368,8.25,16.818,8.25Z']],
  ArrowDotCornerRight1: ['arrow-dot-corner-right-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M19.86,18.429a.375.375,0,1,1,0,.53.374.374,0,0,1,0-.53', 'M16.148,17.368a.375.375,0,1,1,0,.53.375.375,0,0,1,0-.53', 'M13.5,14.716a.375.375,0,1,1,0,.531.375.375,0,0,1,0-.531', 'M8.723,15.247a.375.375,0,1,1,0,.53.374.374,0,0,1,0-.53', 'M6.071,17.9a.375.375,0,1,1,0,.531.377.377,0,0,1,0-.531', 'M11.375,17.9a.375.375,0,1,1,0,.531.375.375,0,0,1,0-.531', 'M18.8,14.716a.375.375,0,1,1,0,.531.377.377,0,0,1,0-.531', 'M16.148,12.065a.375.375,0,1,1,0,.53.374.374,0,0,1,0-.53', 'M10.844,12.065a.375.375,0,1,1,0,.53.375.375,0,0,1,0-.53', 'M13.5,9.413a.375.375,0,1,1,0,.53.375.375,0,0,1,0-.53', 'M8.193,9.413a.375.375,0,1,1,0,.53.375.375,0,0,1,0-.53', 'M10.844,6.761a.375.375,0,1,1,0,.531.377.377,0,0,1,0-.531', 'M5.541,6.761a.375.375,0,1,1,0,.531.375.375,0,0,1,0-.531', 'M8.193,4.11a.375.375,0,1,1,0,.53.374.374,0,0,1,0-.53', 'M16.678,7.292a.375.375,0,1,1,0,.53.374.374,0,0,1,0-.53', 'M19.33,4.64a.375.375,0,1,1,0,.531.375.375,0,0,1,0-.531', 'M19.33,9.943a.375.375,0,1,1,0,.531.375.375,0,0,1,0-.531']],
  ArrowThickCircleLeft: ['arrow-thick-circle-left', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 12.000 A11.250 11.250 0 1 0 23.250 12.000 A11.250 11.250 0 1 0 0.750 12.000 Z', 'M5.982,11.414l5.549-4.439a.75.75,0,0,1,1.219.585V9.75H18a.75.75,0,0,1,.75.75v3a.75.75,0,0,1-.75.75H12.75v2.19a.75.75,0,0,1-1.219.585L5.982,12.586A.751.751,0,0,1,5.982,11.414Z']],
  ArrowThickUp4: ['arrow-thick-up-4', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5',
    transform: 'translate(24 0) rotate(90)'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 0.750 L23.250 0.750 L23.250 23.250 L0.750 23.250 Z', 'M14.25,18V10.5l3.22,3.22a.75.75,0,0,0,1.28-.531V11.121a1.5,1.5,0,0,0-.439-1.06L12.53,4.28a.749.749,0,0,0-1.06,0L5.689,10.061a1.5,1.5,0,0,0-.439,1.06v2.068a.75.75,0,0,0,1.28.531L9.75,10.5V18a.75.75,0,0,0,.75.75h3A.75.75,0,0,0,14.25,18Z']],
  ArrowButtonCircleDown1: ['arrow-button-circle-down-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 12.000 A11.250 11.250 0 1 0 23.250 12.000 A11.250 11.250 0 1 0 0.750 12.000 Z', 'M18.475,9.48l-5.9,7.079a.751.751,0,0,1-1.152,0L5.525,9.48A.75.75,0,0,1,6.1,8.25H8.279a1.5,1.5,0,0,1,1.171.563L12,12l2.55-3.187a1.5,1.5,0,0,1,1.171-.563H17.9A.75.75,0,0,1,18.475,9.48Z']],
  ArrowButtonCircleLeft: ['arrow-button-circle-left', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 12.000 A11.250 11.250 0 1 0 23.250 12.000 A11.250 11.250 0 1 0 0.750 12.000 Z', 'M15.75,16.819V7.183c0-.55-.475-.913-.888-.679l-8.5,4.818a.822.822,0,0,0,0,1.357l8.5,4.819C15.275,17.732,15.75,17.369,15.75,16.819Z']],
  ArrowButtonCircleLeft1: ['arrow-button-circle-left-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 12.000 A11.250 11.250 0 1 0 23.250 12.000 A11.250 11.250 0 1 0 0.750 12.000 Z', 'M14.52,18.475l-7.079-5.9a.751.751,0,0,1,0-1.152l7.079-5.9a.75.75,0,0,1,1.23.576V8.279a1.5,1.5,0,0,1-.563,1.171L12,12l3.187,2.55a1.5,1.5,0,0,1,.563,1.171V17.9A.75.75,0,0,1,14.52,18.475Z']],
  ArrowButtonCircleRight: ['arrow-button-circle-right', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 12.000 A11.250 11.250 0 1 0 23.250 12.000 A11.250 11.250 0 1 0 0.750 12.000 Z', 'M8.25,7.182v9.636c0,.55.475.913.888.679l8.5-4.818a.823.823,0,0,0,0-1.358L9.138,6.5C8.725,6.269,8.25,6.632,8.25,7.182Z']],
  ArrowButtonRight3: ['arrow-button-right-3', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M5.166,22.031,13.191,12,5.166,1.969A.75.75,0,0,1,5.751.75H10.97a1.5,1.5,0,0,1,1.171.563l8.175,10.218a.752.752,0,0,1,0,.938L12.141,22.687a1.5,1.5,0,0,1-1.171.563H5.751A.75.75,0,0,1,5.166,22.031Z']],
  ArrowButtonUp: ['arrow-button-up', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M4.832,18.53,12,11.561l7.168,6.969a.786.786,0,0,0,1.09,0l2.766-2.689a.736.736,0,0,0,0-1.061L12.545,4.591a.786.786,0,0,0-1.09,0L.976,14.78a.736.736,0,0,0,0,1.061L3.742,18.53A.786.786,0,0,0,4.832,18.53Z']],
  ArrowButtonCircleUp1: ['arrow-button-circle-up-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 12.000 A11.250 11.250 0 1 0 23.250 12.000 A11.250 11.250 0 1 0 0.750 12.000 Z', 'M5.525,14.52l5.9-7.079a.751.751,0,0,1,1.152,0l5.9,7.079a.75.75,0,0,1-.576,1.23H15.721a1.5,1.5,0,0,1-1.171-.563L12,12,9.45,15.187a1.5,1.5,0,0,1-1.171.563H6.1A.75.75,0,0,1,5.525,14.52Z']],
  ArrowButtonLeft1: ['arrow-button-left-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M11.689,23.25.97,12.53a.749.749,0,0,1,0-1.06L11.689.75', 'M22.939,23.25,12.22,12.53a.749.749,0,0,1,0-1.06L22.939.75']],
  ArrowButtonDown1: ['arrow-button-down-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M23.25,12.311,12.53,23.03a.749.749,0,0,1-1.06,0L.75,12.311', 'M23.25,1.061,12.53,11.78a.749.749,0,0,1-1.06,0L.75,1.061']],
  ArrowButtonDown: ['arrow-button-down', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M19.168,5.22,12,12.189,4.832,5.22a.786.786,0,0,0-1.09,0L.976,7.909a.736.736,0,0,0,0,1.061L11.455,19.159a.786.786,0,0,0,1.09,0L23.024,8.97a.736.736,0,0,0,0-1.061L20.258,5.22A.786.786,0,0,0,19.168,5.22Z']],
  ArrowButtonCircleUp: ['arrow-button-circle-up', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 12.000 A11.250 11.250 0 1 0 23.250 12.000 A11.250 11.250 0 1 0 0.750 12.000 Z', 'M7.182,15.75h9.636c.55,0,.913-.475.679-.888l-4.818-8.5a.823.823,0,0,0-1.358,0L6.5,14.862C6.269,15.275,6.632,15.75,7.182,15.75Z']],
  ArrowButtonCircleRight1: ['arrow-button-circle-right-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M9.479,5.526l7.079,5.9a.749.749,0,0,1,0,1.152l-7.079,5.9a.75.75,0,0,1-1.23-.576V15.722a1.5,1.5,0,0,1,.563-1.172L12,12,8.812,9.451A1.5,1.5,0,0,1,8.249,8.28V6.1A.75.75,0,0,1,9.479,5.526Z', 'M0.750 12.000 A11.250 11.250 0 1 0 23.250 12.000 A11.250 11.250 0 1 0 0.750 12.000 Z']],
  ArrowButtonDown3: ['arrow-button-down-3', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M1.969,4.185,12,12.21,22.031,4.185a.75.75,0,0,1,1.219.586V9.99a1.5,1.5,0,0,1-.563,1.171L12.469,19.336a.752.752,0,0,1-.938,0L1.313,11.161A1.5,1.5,0,0,1,.75,9.99V4.771A.75.75,0,0,1,1.969,4.185Z']],
  ArrowButtonLeft2: ['arrow-button-left-2', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M2.625,12.637,19.874,22.4A.75.75,0,0,0,21,21.763V2.237A.75.75,0,0,0,19.874,1.6L2.625,11.363A.729.729,0,0,0,2.625,12.637Z']],
  ArrowButtonDown2: ['arrow-button-down-2', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M12.637,21.124,22.4,3.875a.75.75,0,0,0-.637-1.125H2.237A.75.75,0,0,0,1.6,3.875l9.763,17.249A.729.729,0,0,0,12.637,21.124Z']],
  ArrowButtonRight1: ['arrow-button-right-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M12.311.75,23.03,11.47a.749.749,0,0,1,0,1.06L12.311,23.25', 'M1.061.75,11.78,11.47a.749.749,0,0,1,0,1.06L1.061,23.25']],
  ArrowButtonLeft: ['arrow-button-left', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M18.53,19.168,11.561,12,18.53,4.832a.786.786,0,0,0,0-1.09L15.841.976a.736.736,0,0,0-1.061,0L4.591,11.455a.786.786,0,0,0,0,1.09L14.78,23.024a.736.736,0,0,0,1.061,0l2.689-2.766A.786.786,0,0,0,18.53,19.168Z']],
  ArrowButtonRight: ['arrow-button-right', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M5.341,4.832,12.311,12l-6.97,7.168a.786.786,0,0,0,0,1.09L8.03,23.024a.736.736,0,0,0,1.061,0L19.28,12.545a.786.786,0,0,0,0-1.09L9.091.976a.736.736,0,0,0-1.061,0L5.341,3.742A.786.786,0,0,0,5.341,4.832Z']],
  ArrowDotCornerDownRight: ['arrow-dot-corner-down-right', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5',
    transform: 'translate(24 24) rotate(-180)'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 0.750 L23.250 0.750 L23.250 23.250 L0.750 23.250 Z', 'M16.235,7.235a.375.375,0,1,0,.53,0,.374.374,0,0,0-.53,0', 'M15.485,12.485a.375.375,0,1,0,.53,0,.374.374,0,0,0-.53,0', 'M12.485,15.485a.375.375,0,1,0,.53,0,.374.374,0,0,0-.53,0', 'M13.235,10.235a.375.375,0,1,0,.53,0,.374.374,0,0,0-.53,0', 'M10.235,13.235a.375.375,0,1,0,.53,0,.374.374,0,0,0-.53,0', 'M10.985,7.985a.375.375,0,1,0,.53,0,.374.374,0,0,0-.53,0', 'M7.985,10.985a.375.375,0,1,0,.53,0,.374.374,0,0,0-.53,0', 'M8.735,5.735a.375.375,0,1,0,.53,0,.374.374,0,0,0-.53,0', 'M5.735,8.735a.375.375,0,1,0,.53,0,.374.374,0,0,0-.53,0', 'M16.235,16.235a.375.375,0,1,0,.53,0,.374.374,0,0,0-.53,0', 'M7.235,16.235a.375.375,0,1,0,.53,0,.374.374,0,0,0-.53,0']],
  ArrowDotCornerDownLeft: ['arrow-dot-corner-down-left', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 0.750 L23.250 0.750 L23.250 23.250 L0.750 23.250 Z', 'M7.765,7.235a.375.375,0,1,1-.53,0,.374.374,0,0,1,.53,0', 'M8.515,12.485a.375.375,0,1,1-.53,0,.374.374,0,0,1,.53,0', 'M11.515,15.485a.375.375,0,1,1-.53,0,.374.374,0,0,1,.53,0', 'M10.765,10.235a.375.375,0,1,1-.53,0,.374.374,0,0,1,.53,0', 'M13.765,13.235a.375.375,0,1,1-.53,0,.374.374,0,0,1,.53,0', 'M13.015,7.985a.375.375,0,1,1-.53,0,.374.374,0,0,1,.53,0', 'M16.015,10.985a.375.375,0,1,1-.53,0,.374.374,0,0,1,.53,0', 'M15.265,5.735a.375.375,0,1,1-.53,0,.374.374,0,0,1,.53,0', 'M18.265,8.735a.375.375,0,1,1-.53,0,.374.374,0,0,1,.53,0', 'M7.765,16.235a.375.375,0,1,1-.53,0,.374.374,0,0,1,.53,0', 'M16.765,16.235a.375.375,0,1,1-.53,0,.374.374,0,0,1,.53,0']],
  ArrowDoubleDown: ['arrow-double-down', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M11.75,16.778l7.1-4.517A.751.751,0,0,1,20,12.894v4.561a1.5,1.5,0,0,1-.7,1.265l-6.75,4.3a1.5,1.5,0,0,1-1.61,0L4.2,18.72a1.5,1.5,0,0,1-.7-1.265V12.894a.751.751,0,0,1,1.153-.633Z', 'M11.75,5.384l7.1-4.517A.751.751,0,0,1,20,1.5V6.06a1.5,1.5,0,0,1-.7,1.266l-6.75,4.3a1.5,1.5,0,0,1-1.61,0L4.2,7.326A1.5,1.5,0,0,1,3.5,6.06V1.5A.751.751,0,0,1,4.653.867Z']],
  ArrowThickCircleDown2: ['arrow-thick-circle-down-2', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 12.000 A11.250 11.250 0 1 0 23.250 12.000 A11.250 11.250 0 1 0 0.750 12.000 Z', 'M12,5.25A2.25,2.25,0,0,0,9.75,7.5v5.25L8.625,11.625a1.592,1.592,0,0,0-2.25,0h0a1.592,1.592,0,0,0,0,2.25l5.1,5.095a.749.749,0,0,0,1.06,0l5.1-5.095a1.592,1.592,0,0,0,0-2.25h0a1.592,1.592,0,0,0-2.25,0L14.25,12.75V7.5A2.25,2.25,0,0,0,12,5.25Z']],
  ArrowDotDown1: ['arrow-dot-down-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M12,20.875a.375.375,0,1,1-.375.375A.375.375,0,0,1,12,20.875', 'M10.125,17.5a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375', 'M10.125,13.75a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375', 'M6.375,10.75A.375.375,0,1,1,6,11.125a.375.375,0,0,1,.375-.375', 'M2.625,10.75a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375', 'M6.375,14.5A.375.375,0,1,1,6,14.875a.375.375,0,0,1,.375-.375', 'M13.875,17.5a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375', 'M13.875,13.75a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375', 'M10.125,10a.375.375,0,1,1-.375.375A.375.375,0,0,1,10.125,10', 'M13.875,10a.375.375,0,1,1-.375.375A.375.375,0,0,1,13.875,10', 'M10.125,6.25a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375', 'M13.875,6.25a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375', 'M10.125,2.5a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375', 'M13.875,2.5a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375', 'M17.625,10.75a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375', 'M21.375,10.75a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375', 'M17.625,14.5a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375']],
  ArrowDotUp: ['arrow-dot-up', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5',
    transform: 'translate(24 0) rotate(90)'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 0.750 L23.250 0.750 L23.250 23.250 L0.750 23.250 Z', 'M11.625,4.5A.375.375,0,1,1,12,4.875a.375.375,0,0,1-.375-.375', 'M13.5,7.875a.375.375,0,1,1,.375.375.375.375,0,0,1-.375-.375', 'M13.5,11.625a.375.375,0,1,1,.375.375.375.375,0,0,1-.375-.375', 'M17.25,11.625a.375.375,0,1,1,.375.375.375.375,0,0,1-.375-.375', 'M9.75,7.875a.375.375,0,1,1,.375.375.375.375,0,0,1-.375-.375', 'M9.75,11.625a.375.375,0,1,1,.375.375.375.375,0,0,1-.375-.375', 'M13.5,15.375a.375.375,0,1,1,.375.375.375.375,0,0,1-.375-.375', 'M9.75,15.375a.375.375,0,1,1,.375.375.375.375,0,0,1-.375-.375', 'M13.5,19.125a.375.375,0,1,1,.375.375.375.375,0,0,1-.375-.375', 'M9.75,19.125a.375.375,0,1,1,.375.375.375.375,0,0,1-.375-.375', 'M6,11.625A.375.375,0,1,1,6.375,12,.375.375,0,0,1,6,11.625']],
  ArrowDotUp1: ['arrow-dot-up-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M12.25,3a.375.375,0,1,1,.375-.375A.375.375,0,0,1,12.25,3', 'M14.125,6.375A.375.375,0,1,1,14.5,6a.375.375,0,0,1-.375.375', 'M14.125,10.125A.375.375,0,1,1,14.5,9.75a.375.375,0,0,1-.375.375', 'M17.875,13.125a.375.375,0,1,1,.375-.375.375.375,0,0,1-.375.375', 'M21.625,13.125A.375.375,0,1,1,22,12.75a.375.375,0,0,1-.375.375', 'M17.875,9.375A.375.375,0,1,1,18.25,9a.375.375,0,0,1-.375.375', 'M10.375,6.375A.375.375,0,1,1,10.75,6a.375.375,0,0,1-.375.375', 'M10.375,10.125a.375.375,0,1,1,.375-.375.375.375,0,0,1-.375.375', 'M14.125,13.875A.375.375,0,1,1,14.5,13.5a.375.375,0,0,1-.375.375', 'M10.375,13.875a.375.375,0,1,1,.375-.375.375.375,0,0,1-.375.375', 'M14.125,17.625a.375.375,0,1,1,.375-.375.375.375,0,0,1-.375.375', 'M10.375,17.625a.375.375,0,1,1,.375-.375.375.375,0,0,1-.375.375', 'M14.125,21.375A.375.375,0,1,1,14.5,21a.375.375,0,0,1-.375.375', 'M10.375,21.375A.375.375,0,1,1,10.75,21a.375.375,0,0,1-.375.375', 'M6.625,13.125A.375.375,0,1,1,7,12.75a.375.375,0,0,1-.375.375', 'M2.875,13.125a.375.375,0,1,1,.375-.375.375.375,0,0,1-.375.375', 'M6.625,9.375A.375.375,0,1,1,7,9a.375.375,0,0,1-.375.375']],
  ArrowDoubleRight1: ['arrow-double-right-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M14.59,18.289l4.162-6.54L14.59,5.211c-.424-.667-.08-1.711.565-1.711h2.411a1.372,1.372,0,0,1,1.129.7l4.369,6.866a1.332,1.332,0,0,1,0,1.358L18.7,19.3a1.372,1.372,0,0,1-1.129.7H15.155C14.51,20,14.166,18.956,14.59,18.289Z', 'M6.187,18.289l4.162-6.539L6.187,5.211c-.424-.667-.08-1.711.564-1.711H8.522a1.371,1.371,0,0,1,1.129.7l4.37,6.867a1.337,1.337,0,0,1,0,1.358L9.651,19.3a1.371,1.371,0,0,1-1.129.7H6.751C6.107,20,5.763,18.956,6.187,18.289Z', 'M0.75 19.25L6 11.75 0.75 4.25']],
  ArrowDoubleLeft: ['arrow-double-left', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M7.222,11.75l4.517,7.1A.751.751,0,0,1,11.106,20H6.545a1.5,1.5,0,0,1-1.265-.7L.985,12.555a1.5,1.5,0,0,1,0-1.61L5.28,4.2a1.5,1.5,0,0,1,1.265-.7h4.561a.751.751,0,0,1,.633,1.153Z', 'M18.616,11.75l4.517,7.1A.751.751,0,0,1,22.5,20H17.94a1.5,1.5,0,0,1-1.266-.7l-4.295-6.75a1.5,1.5,0,0,1,0-1.61l4.3-6.75a1.5,1.5,0,0,1,1.266-.7H22.5a.751.751,0,0,1,.633,1.153Z']],
  ArrowDoubleUp1: ['arrow-double-up-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M18.289,9.41l-6.54-4.162L5.211,9.41c-.667.424-1.711.08-1.711-.565V6.434a1.372,1.372,0,0,1,.7-1.129L11.07.936a1.332,1.332,0,0,1,1.358,0L19.3,5.305A1.372,1.372,0,0,1,20,6.434V8.845C20,9.49,18.956,9.834,18.289,9.41Z', 'M18.289,17.813,11.75,13.651,5.211,17.813c-.667.424-1.711.08-1.711-.564V15.478a1.371,1.371,0,0,1,.7-1.129l6.867-4.37a1.337,1.337,0,0,1,1.358,0l6.867,4.37a1.371,1.371,0,0,1,.7,1.129v1.771C20,17.893,18.956,18.237,18.289,17.813Z', 'M19.25 23.25L11.75 18 4.25 23.25']],
  ArrowDoubleRight: ['arrow-double-right', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M16.778,12.25l-4.517-7.1A.751.751,0,0,1,12.894,4h4.561a1.5,1.5,0,0,1,1.265.7l4.3,6.75a1.5,1.5,0,0,1,0,1.61l-4.3,6.75a1.5,1.5,0,0,1-1.265.7H12.894a.751.751,0,0,1-.633-1.153Z', 'M5.384,12.25.867,5.153A.751.751,0,0,1,1.5,4H6.06a1.5,1.5,0,0,1,1.266.7l4.3,6.75a1.5,1.5,0,0,1,0,1.61l-4.3,6.75a1.5,1.5,0,0,1-1.266.7H1.5a.751.751,0,0,1-.633-1.153Z']],
  ArrowLeft: ['arrow-left', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M23.25 12L0.75 12', 'M11.25 1.5L0.75 12 11.25 22.5']],
  ArrowRectangleDown1: ['arrow-rectangle-down-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 0.750 L23.250 0.750 L23.250 23.250 L0.750 23.250 Z', 'M6.649,8.587,12,12.749l5.35-4.162a.859.859,0,0,1,1.4.565v2.166a1.433,1.433,0,0,1-.577,1.129l-5.618,4.37a.926.926,0,0,1-1.111,0l-5.618-4.37a1.435,1.435,0,0,1-.576-1.129V9.152A.858.858,0,0,1,6.649,8.587Z']],
  ArrowRectangleDown2: ['arrow-rectangle-down-2', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 0.750 L23.250 0.750 L23.250 23.250 L0.750 23.250 Z', 'M6.649,6.937,12,11.1l5.351-4.162a.858.858,0,0,1,1.4.564v4.417a1.436,1.436,0,0,1-.576,1.129l-5.618,4.369a.924.924,0,0,1-1.112,0L5.826,13.047a1.436,1.436,0,0,1-.576-1.129V7.5A.858.858,0,0,1,6.649,6.937Z']],
  ArrowLeftX: ['arrow-left-x', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M21.531,20.5H7.992a1.5,1.5,0,0,1-1.161-.55L.92,12.725a.748.748,0,0,1,0-.95L6.831,4.55A1.5,1.5,0,0,1,7.992,4H21.531a1.5,1.5,0,0,1,1.5,1.5V19A1.5,1.5,0,0,1,21.531,20.5Z', 'M11.031 8.5L18.531 16', 'M18.531 8.5L11.031 16']],
  ArrowLeft2: ['arrow-left-2', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M21.439,20.25H9.311a1.5,1.5,0,0,1-1.061-.439L.97,12.53a.749.749,0,0,1,0-1.06L8.25,4.189A1.5,1.5,0,0,1,9.311,3.75H21.439a1.5,1.5,0,0,1,1.5,1.5v13.5A1.5,1.5,0,0,1,21.439,20.25Z']],
  ArrowRectangleRight1: ['arrow-rectangle-right-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5',
    transform: 'translate(0 24) rotate(-90)'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 0.750 L23.250 0.750 L23.250 23.250 L0.750 23.250 Z', 'M8.589,17.351,12.75,12,8.589,6.65a.858.858,0,0,1,.564-1.4H11.32a1.433,1.433,0,0,1,1.128.576l4.37,5.618a.926.926,0,0,1,0,1.111l-4.37,5.618a1.434,1.434,0,0,1-1.128.577H9.153A.858.858,0,0,1,8.589,17.351Z']],
  ArrowRectangleLeft1: ['arrow-rectangle-left-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5',
    transform: 'translate(24 0) rotate(90)'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 0.750 L23.250 0.750 L23.250 23.250 L0.750 23.250 Z', 'M15.412,6.65,11.25,12l4.162,5.351a.858.858,0,0,1-.565,1.4H12.681a1.435,1.435,0,0,1-1.129-.576l-4.37-5.618a.926.926,0,0,1,0-1.111l4.37-5.618a1.433,1.433,0,0,1,1.129-.577h2.166A.859.859,0,0,1,15.412,6.65Z']],
  ArrowRectangleLeft2: ['arrow-rectangle-left-2', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5',
    transform: 'translate(24 0) rotate(90)'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 0.750 L23.250 0.750 L23.250 23.250 L0.750 23.250 Z', 'M17.063,6.649,12.9,12l4.162,5.351a.858.858,0,0,1-.564,1.4H12.082a1.436,1.436,0,0,1-1.129-.576L6.584,12.556a.924.924,0,0,1,0-1.112l4.369-5.618a1.436,1.436,0,0,1,1.129-.576H16.5A.858.858,0,0,1,17.063,6.649Z']],
  ArrowRectangleRight2: ['arrow-rectangle-right-2', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5',
    transform: 'translate(0 24) rotate(-90)'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 0.750 L23.250 0.750 L23.250 23.250 L0.750 23.250 Z', 'M6.937,17.351,11.1,12,6.937,6.649A.858.858,0,0,1,7.5,5.25h4.417a1.436,1.436,0,0,1,1.129.576l4.369,5.618a.924.924,0,0,1,0,1.112l-4.369,5.618a1.436,1.436,0,0,1-1.129.576H7.5A.858.858,0,0,1,6.937,17.351Z']],
  ArrowThickCircleDown1: ['arrow-thick-circle-down-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 12.000 A11.250 11.250 0 1 0 23.250 12.000 A11.250 11.250 0 1 0 0.750 12.000 Z', 'M10.5,5.25A.75.75,0,0,0,9.75,6v6.75L8.03,11.03a.749.749,0,0,0-1.06,0L5.78,12.22a.749.749,0,0,0,0,1.06l5.69,5.69a.749.749,0,0,0,1.06,0l5.69-5.69a.749.749,0,0,0,0-1.06l-1.19-1.19a.749.749,0,0,0-1.06,0l-1.72,1.72V6a.75.75,0,0,0-.75-.75Z']],
  ArrowRectangleUp1: ['arrow-rectangle-up-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5',
    transform: 'translate(24 24) rotate(180)'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 0.750 L23.250 0.750 L23.250 23.250 L0.750 23.250 Z', 'M17.351,15.412,12,11.25,6.649,15.412a.858.858,0,0,1-1.4-.565V12.681a1.435,1.435,0,0,1,.576-1.129l5.618-4.37a.927.927,0,0,1,1.112,0l5.618,4.37a1.435,1.435,0,0,1,.576,1.129v2.166A.858.858,0,0,1,17.351,15.412Z']],
  ArrowThickCircleBottomLeftCorner: ['arrow-thick-circle-bottom-left-corner', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 12.000 A11.250 11.250 0 1 0 23.250 12.000 A11.250 11.250 0 1 0 0.750 12.000 Z', 'M7.331,15.841l.784-7.063A.751.751,0,0,1,9.391,8.33l1.548,1.549,3.713-3.713a.749.749,0,0,1,1.06,0l2.122,2.122a.749.749,0,0,1,0,1.06l-3.713,3.713,1.549,1.548a.751.751,0,0,1-.448,1.276l-7.063.784A.749.749,0,0,1,7.331,15.841Z']],
  ArrowThickCircleBottomRightCorner1: ['arrow-thick-circle-bottom-right-corner-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 12.000 A11.250 11.250 0 1 0 23.250 12.000 A11.250 11.250 0 1 0 0.750 12.000 Z', 'M8.132,6.231a.75.75,0,0,1,1.061,0L13.966,11V8.572a.75.75,0,0,1,.75-.75H16.4a.75.75,0,0,1,.75.75v8.046a.75.75,0,0,1-.75.75H8.352a.75.75,0,0,1-.75-.75V14.936a.75.75,0,0,1,.75-.75h2.432L6.011,9.413a.75.75,0,0,1,0-1.061Z']],
  ArrowRightX: ['arrow-right-x', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M2.469,4H16.008a1.5,1.5,0,0,1,1.161.55l5.911,7.225a.748.748,0,0,1,0,.95L17.169,19.95a1.5,1.5,0,0,1-1.161.55H2.469A1.5,1.5,0,0,1,.969,19V5.5A1.5,1.5,0,0,1,2.469,4Z', 'M12.969 16L5.469 8.5', 'M5.469 16L12.969 8.5']],
  ArrowThickCircleBottomLeftCorner1: ['arrow-thick-circle-bottom-left-corner-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 12.000 A11.250 11.250 0 1 0 23.250 12.000 A11.250 11.250 0 1 0 0.750 12.000 Z', 'M15.868,6.231a.75.75,0,0,0-1.061,0L10.034,11V8.572a.75.75,0,0,0-.75-.75H7.6a.75.75,0,0,0-.75.75v8.046a.75.75,0,0,0,.75.75h8.046a.75.75,0,0,0,.75-.75V14.936a.75.75,0,0,0-.75-.75H13.216l4.773-4.773a.75.75,0,0,0,0-1.061Z']],
  ArrowThickCircleBottomRightCorner: ['arrow-thick-circle-bottom-right-corner', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 12.000 A11.250 11.250 0 1 0 23.250 12.000 A11.250 11.250 0 1 0 0.750 12.000 Z', 'M15.841,16.669l-7.063-.784a.751.751,0,0,1-.448-1.276l1.549-1.548L6.166,9.348a.749.749,0,0,1,0-1.06L8.288,6.166a.749.749,0,0,1,1.06,0l3.713,3.713L14.609,8.33a.751.751,0,0,1,1.276.448l.784,7.063A.749.749,0,0,1,15.841,16.669Z']],
  ArrowThickCircleLeft1: ['arrow-thick-circle-left-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 12.000 A11.250 11.250 0 1 0 23.250 12.000 A11.250 11.250 0 1 0 0.750 12.000 Z', 'M18.75,10.5A.75.75,0,0,0,18,9.75H11.25l1.72-1.72a.749.749,0,0,0,0-1.06L11.78,5.78a.749.749,0,0,0-1.06,0L5.03,11.47a.749.749,0,0,0,0,1.06l5.69,5.69a.749.749,0,0,0,1.06,0l1.19-1.19a.749.749,0,0,0,0-1.06l-1.72-1.72H18a.75.75,0,0,0,.75-.75Z']],
  ArrowThickCircleRight: ['arrow-thick-circle-right', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 12.000 A11.250 11.250 0 1 0 23.250 12.000 A11.250 11.250 0 1 0 0.750 12.000 Z', 'M18.018,12.586l-5.549,4.439a.75.75,0,0,1-1.219-.585V14.25H6a.75.75,0,0,1-.75-.75v-3A.75.75,0,0,1,6,9.75h5.25V7.56a.75.75,0,0,1,1.219-.585l5.549,4.439A.751.751,0,0,1,18.018,12.586Z']],
  ArrowThickCircleRight2: ['arrow-thick-circle-right-2', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 12.000 A11.250 11.250 0 1 0 23.250 12.000 A11.250 11.250 0 1 0 0.750 12.000 Z', 'M5.25,12A2.25,2.25,0,0,0,7.5,14.25h5.25l-1.125,1.125a1.592,1.592,0,0,0,0,2.25h0a1.592,1.592,0,0,0,2.25,0l5.095-5.1a.749.749,0,0,0,0-1.06l-5.095-5.1a1.592,1.592,0,0,0-2.25,0h0a1.592,1.592,0,0,0,0,2.25L12.75,9.75H7.5A2.25,2.25,0,0,0,5.25,12Z']],
  ArrowThickCircleUp: ['arrow-thick-circle-up', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 12.000 A11.250 11.250 0 1 0 23.250 12.000 A11.250 11.250 0 1 0 0.750 12.000 Z', 'M12.586,5.982l4.439,5.549a.75.75,0,0,1-.585,1.219H14.25V18a.75.75,0,0,1-.75.75h-3A.75.75,0,0,1,9.75,18V12.75H7.56a.75.75,0,0,1-.585-1.219l4.439-5.549A.751.751,0,0,1,12.586,5.982Z']],
  ArrowThickCircleUp1: ['arrow-thick-circle-up-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 12.000 A11.250 11.250 0 1 0 23.250 12.000 A11.250 11.250 0 1 0 0.750 12.000 Z', 'M13.5,18.75a.75.75,0,0,0,.75-.75V11.25l1.72,1.72a.749.749,0,0,0,1.06,0l1.19-1.19a.749.749,0,0,0,0-1.06L12.53,5.03a.749.749,0,0,0-1.06,0L5.78,10.72a.749.749,0,0,0,0,1.06l1.19,1.19a.749.749,0,0,0,1.06,0l1.72-1.72V18a.75.75,0,0,0,.75.75Z']],
  ArrowThickCircleUp2: ['arrow-thick-circle-up-2', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 12.000 A11.250 11.250 0 1 0 23.250 12.000 A11.250 11.250 0 1 0 0.750 12.000 Z', 'M12,18.75a2.25,2.25,0,0,0,2.25-2.25V11.25l1.125,1.125a1.592,1.592,0,0,0,2.25,0h0a1.592,1.592,0,0,0,0-2.25L12.53,5.03a.749.749,0,0,0-1.06,0l-5.1,5.1a1.592,1.592,0,0,0,0,2.25h0a1.592,1.592,0,0,0,2.25,0L9.75,11.25V16.5A2.25,2.25,0,0,0,12,18.75Z']],
  ArrowThickCircleLeft2: ['arrow-thick-circle-left-2', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 12.000 A11.250 11.250 0 1 0 23.250 12.000 A11.250 11.250 0 1 0 0.750 12.000 Z', 'M18.75,12A2.25,2.25,0,0,0,16.5,9.75H11.25l1.125-1.125a1.592,1.592,0,0,0,0-2.25h0a1.592,1.592,0,0,0-2.25,0L5.03,11.47a.749.749,0,0,0,0,1.06l5.1,5.1a1.592,1.592,0,0,0,2.25,0h0a1.592,1.592,0,0,0,0-2.25L11.25,14.25H16.5A2.25,2.25,0,0,0,18.75,12Z']],
  ArrowThickDotCornerDownRight: ['arrow-thick-dot-corner-down-right', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M18.11,17.86a.375.375,0,1,1,0,.53.374.374,0,0,1,0-.53', 'M12.64,17.86a.375.375,0,1,1-.53,0,.374.374,0,0,1,.53,0', 'M18.64,5.86a.375.375,0,1,1-.53,0,.374.374,0,0,1,.53,0', 'M13.61,13.36a.375.375,0,1,1,0,.53.374.374,0,0,1,0-.53', 'M9.11,8.86a.375.375,0,1,1,0,.53.374.374,0,0,1,0-.53', 'M4.61,4.36a.375.375,0,1,1,0,.53.374.374,0,0,1,0-.53', 'M18.64,11.86a.375.375,0,1,1-.53,0,.374.374,0,0,1,.53,0', 'M6.64,17.86a.375.375,0,1,1-.53,0,.374.374,0,0,1,.53,0']],
  ArrowThickDotLeft: ['arrow-thick-dot-left', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M2.875,11.5a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375', 'M5.875,7a.375.375,0,1,1-.375.375A.375.375,0,0,1,5.875,7', 'M8.875,20.5a.375.375,0,1,1,.375-.375.375.375,0,0,1-.375.375', 'M8.875,11.5a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375', 'M14.875,11.5a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375', 'M20.875,11.5a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375', 'M5.875,16.75a.375.375,0,1,1,.375-.375.375.375,0,0,1-.375.375', 'M8.875,3.25a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375']],
  ArrowThickDown: ['arrow-thick-down', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M7.5,1.5v9.75H3.758a.749.749,0,0,0-.587,1.223l8.242,10.5a.761.761,0,0,0,1.174,0l8.242-10.5a.749.749,0,0,0-.587-1.223H16.5V1.5a.753.753,0,0,0-.756-.75H8.256A.753.753,0,0,0,7.5,1.5Z']],
  ArrowThickDotUp: ['arrow-thick-dot-up', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M11.875,2.5a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375', 'M16.375,5.5A.375.375,0,1,1,16,5.875a.375.375,0,0,1,.375-.375', 'M3.625,8.5a.375.375,0,1,1-.375.375A.375.375,0,0,1,3.625,8.5', 'M11.875,8.5a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375', 'M11.875,14.5a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375', 'M11.875,20.5a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375', 'M7.375,5.5A.375.375,0,1,1,7,5.875.375.375,0,0,1,7.375,5.5', 'M20.125,8.5a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375']],
  ArrowThickDown1: ['arrow-thick-down-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M22.122,13.8a.75.75,0,0,0,0-1.061L20,10.613a.75.75,0,0,0-1.061,0L14.3,15.257V1.5a.75.75,0,0,0-.75-.75h-3a.75.75,0,0,0-.75.75V15.257L5.152,10.613a.75.75,0,0,0-1.061,0L1.97,12.734a.75.75,0,0,0,0,1.061l9.015,9.016a1.5,1.5,0,0,0,2.122,0Z']],
  ArrowThickDown2: ['arrow-thick-down-2', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M11.856.75A2.25,2.25,0,0,0,9.606,3V15.568L6.552,12.515A2.25,2.25,0,0,0,3.37,15.7l6.9,6.894a2.25,2.25,0,0,0,3.182,0L20.341,15.7a2.25,2.25,0,1,0-3.182-3.182l-3.053,3.053V3A2.25,2.25,0,0,0,11.856.75Z']],
  ArrowThickDown4: ['arrow-thick-down-4', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5',
    transform: 'translate(0 24) rotate(-90)'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 0.750 L23.250 0.750 L23.250 23.250 L0.750 23.250 Z', 'M9.75,6v7.5L6.53,10.28a.75.75,0,0,0-1.28.531v2.068a1.5,1.5,0,0,0,.439,1.06L11.47,19.72a.749.749,0,0,0,1.06,0l5.781-5.781a1.5,1.5,0,0,0,.439-1.06V10.811a.75.75,0,0,0-1.28-.531L14.25,13.5V6a.75.75,0,0,0-.75-.75h-3A.75.75,0,0,0,9.75,6Z']],
  ArrowThickDown3: ['arrow-thick-down-3', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M20.25,10.757a.75.75,0,0,0-1.28-.53l-4.72,4.72V1.5A.75.75,0,0,0,13.5.75h-3a.75.75,0,0,0-.75.75V14.947l-4.72-4.72a.75.75,0,0,0-1.28.53v3.932a1.5,1.5,0,0,0,.439,1.061l7.281,7.28a.749.749,0,0,0,1.06,0l7.281-7.28a1.5,1.5,0,0,0,.439-1.061Z']],
  ArrowThickLeft2: ['arrow-thick-left-2', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M23.25,12.394A2.25,2.25,0,0,0,21,10.144H8.432l3.053-3.053A2.25,2.25,0,1,0,8.3,3.909L1.409,10.8a2.25,2.25,0,0,0,0,3.182L8.3,20.88A2.25,2.25,0,1,0,11.485,17.7L8.432,14.644H21A2.248,2.248,0,0,0,23.25,12.394Z']],
  ArrowThickLeft1: ['arrow-thick-left-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M10.205,22.03a.75.75,0,0,0,1.061,0l2.121-2.121a.75.75,0,0,0,0-1.061L8.743,14.2H22.5a.75.75,0,0,0,.75-.75v-3a.75.75,0,0,0-.75-.75H8.743L13.387,5.06a.75.75,0,0,0,0-1.061L11.266,1.878a.75.75,0,0,0-1.061,0L1.189,10.893a1.5,1.5,0,0,0,0,2.122Z']],
  ArrowThickLeft: ['arrow-thick-left', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M22.5,7.75H12.75V4.008a.749.749,0,0,0-1.223-.587l-10.5,8.242a.761.761,0,0,0,0,1.174l10.5,8.242a.749.749,0,0,0,1.223-.587V16.75H22.5a.753.753,0,0,0,.75-.756V8.506A.753.753,0,0,0,22.5,7.75Z']],
  ArrowThickLeft4: ['arrow-thick-left-4', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 0.750 L23.250 0.750 L23.250 23.250 L0.750 23.250 Z', 'M18,9.75H10.5l3.22-3.22a.75.75,0,0,0-.531-1.28H11.121a1.5,1.5,0,0,0-1.06.439L4.28,11.47a.749.749,0,0,0,0,1.06l5.781,5.781a1.5,1.5,0,0,0,1.06.439h2.068a.75.75,0,0,0,.531-1.28L10.5,14.25H18a.75.75,0,0,0,.75-.75v-3A.75.75,0,0,0,18,9.75Z']],
  ArrowThickLeftBottomCorner: ['arrow-thick-left-bottom-corner', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M22.991,8.544l-8.163,8.163,3.134,3.133a.887.887,0,0,1-.533,1.515L1.737,23.246a.9.9,0,0,1-.983-.983L2.645,6.571A.887.887,0,0,1,4.16,6.038L7.293,9.172l8.163-8.163a.891.891,0,0,1,1.261.005l6.269,6.269A.891.891,0,0,1,22.991,8.544Z']],
  ArrowThickLeftBottomCorner4: ['arrow-thick-left-bottom-corner-4', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5',
    transform: 'translate(0 24) rotate(-90)'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 0.750 L23.250 0.750 L23.250 23.250 L0.750 23.250 Z', 'M15.235,5.583,9.764,11.054V6.5a.75.75,0,0,0-1.28-.53l-1.295,1.3a1.5,1.5,0,0,0-.439,1.06V16.5a.75.75,0,0,0,.75.75h8.175a1.5,1.5,0,0,0,1.06-.439l1.3-1.295a.75.75,0,0,0-.53-1.28H12.946l5.471-5.471a.75.75,0,0,0,0-1.061L16.3,5.583A.75.75,0,0,0,15.235,5.583Z']],
  ArrowThickRight2: ['arrow-thick-right-2', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M.75,12.394A2.25,2.25,0,0,0,3,14.644H15.568L12.515,17.7A2.25,2.25,0,1,0,15.7,20.88l6.894-6.895a2.25,2.25,0,0,0,0-3.182L15.7,3.909a2.25,2.25,0,0,0-3.182,3.182l3.053,3.053H3A2.25,2.25,0,0,0,.75,12.394Z']],
  ArrowThickRight1: ['arrow-thick-right-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M13.8,2.128a.75.75,0,0,0-1.061,0L10.613,4.249a.75.75,0,0,0,0,1.061l4.644,4.644H1.5a.75.75,0,0,0-.75.75v3a.75.75,0,0,0,.75.75H15.257L10.613,19.1a.75.75,0,0,0,0,1.061l2.121,2.121a.75.75,0,0,0,1.061,0l9.016-9.015a1.5,1.5,0,0,0,0-2.122Z']],
  ArrowThickLeftBottomCorner2: ['arrow-thick-left-bottom-corner-2', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M19.841,4.681a2.249,2.249,0,0,0-3.182,0L7.772,13.568V9.25a2.25,2.25,0,0,0-4.5,0V19a2.25,2.25,0,0,0,2.25,2.25h9.75a2.25,2.25,0,0,0,0-4.5H10.954l8.887-8.887A2.249,2.249,0,0,0,19.841,4.681Z']],
  ArrowThickLeftBottomCorner3: ['arrow-thick-left-bottom-corner-3', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M20.53,5.591,18.409,3.47a.75.75,0,0,0-1.061,0L7.84,12.978V6.41a.75.75,0,0,0-1.28-.53L3.779,8.66A1.5,1.5,0,0,0,3.34,9.721V19.91a.75.75,0,0,0,.75.75H14.279a1.5,1.5,0,0,0,1.061-.439l2.78-2.781a.75.75,0,0,0-.53-1.28H11.022L20.53,6.652A.75.75,0,0,0,20.53,5.591Z']],
  ArrowThickRight4: ['arrow-thick-right-4', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5',
    transform: 'translate(24 24) rotate(-180)'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 0.750 L23.250 0.750 L23.250 23.250 L0.750 23.250 Z', 'M6,9.75h7.5L10.28,6.53a.75.75,0,0,1,.531-1.28h2.068a1.5,1.5,0,0,1,1.06.439L19.72,11.47a.749.749,0,0,1,0,1.06l-5.781,5.781a1.5,1.5,0,0,1-1.06.439H10.811a.75.75,0,0,1-.531-1.28l3.22-3.22H6a.75.75,0,0,1-.75-.75v-3A.75.75,0,0,1,6,9.75Z']],
  ArrowThickRightBottomCorner4: ['arrow-thick-right-bottom-corner-4', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5',
    transform: 'translate(0 24) rotate(-90)'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 0.750 L23.250 0.750 L23.250 23.250 L0.750 23.250 Z', 'M8.765,5.583l5.471,5.471V6.5a.75.75,0,0,1,1.28-.53l1.3,1.3a1.5,1.5,0,0,1,.439,1.06V16.5a.75.75,0,0,1-.75.75H8.325a1.5,1.5,0,0,1-1.06-.439L5.97,15.516a.75.75,0,0,1,.53-1.28h4.554L5.583,8.765a.75.75,0,0,1,0-1.061L7.7,5.583A.75.75,0,0,1,8.765,5.583Z']],
  ArrowThickUp2: ['arrow-thick-up-2', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M11.894,23.25A2.25,2.25,0,0,0,14.144,21V8.432L17.2,11.485A2.25,2.25,0,1,0,20.38,8.3L13.485,1.409a2.25,2.25,0,0,0-3.182,0L3.409,8.3a2.25,2.25,0,0,0,3.182,3.182L9.644,8.432V21A2.25,2.25,0,0,0,11.894,23.25Z']],
  ArrowThickRightBottomCorner: ['arrow-thick-right-bottom-corner', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M8.544,1.009l8.163,8.163L19.84,6.038a.887.887,0,0,1,1.515.533l1.891,15.692a.9.9,0,0,1-.983.983L6.571,21.355a.887.887,0,0,1-.533-1.515l3.134-3.133L1.009,8.544a.891.891,0,0,1,.005-1.261L7.283,1.014A.891.891,0,0,1,8.544,1.009Z']],
  ArrowThickUp3: ['arrow-thick-up-3', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M3.75,13.243a.75.75,0,0,0,1.28.53l4.72-4.72V22.5a.75.75,0,0,0,.75.75h3a.75.75,0,0,0,.75-.75V9.053l4.72,4.72a.75.75,0,0,0,1.28-.53V9.311a1.5,1.5,0,0,0-.439-1.061L12.53.97a.749.749,0,0,0-1.06,0L4.189,8.25A1.5,1.5,0,0,0,3.75,9.311Z']],
  ArrowThickUp: ['arrow-thick-up', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M7.5,22.5V12.75H3.758a.749.749,0,0,1-.587-1.223l8.242-10.5a.761.761,0,0,1,1.174,0l8.242,10.5a.749.749,0,0,1-.587,1.223H16.5V22.5a.753.753,0,0,1-.756.75H8.256A.753.753,0,0,1,7.5,22.5Z']],
  ArrowThickRightBottomCorner2: ['arrow-thick-right-bottom-corner-2', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M3.409,4.431a2.249,2.249,0,0,0,0,3.182L12.3,16.5H7.978a2.25,2.25,0,0,0,0,4.5h9.75a2.25,2.25,0,0,0,2.25-2.25V9a2.25,2.25,0,0,0-4.5,0v4.318L6.591,4.431A2.249,2.249,0,0,0,3.409,4.431Z']],
  ArrowThickRightBottomCorner3: ['arrow-thick-right-bottom-corner-3', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M3.81,6.341,5.931,4.22a.75.75,0,0,1,1.061,0L16.5,13.728V7.16a.75.75,0,0,1,1.28-.53l2.781,2.78A1.5,1.5,0,0,1,21,10.471V20.66a.75.75,0,0,1-.75.75H10.061A1.5,1.5,0,0,1,9,20.971L6.22,18.19a.75.75,0,0,1,.53-1.28h6.568L3.81,7.4A.75.75,0,0,1,3.81,6.341Z']],
  ArrowUp: ['arrow-up', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M12 23.25L12 0.75', 'M22.5 11.25L12 0.75 1.5 11.25']],
  ArrowButtonLeft3: ['arrow-button-left-3', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M19.315,1.969,11.29,12l8.025,10.031a.75.75,0,0,1-.586,1.219H13.51a1.5,1.5,0,0,1-1.171-.563L4.164,12.469a.752.752,0,0,1,0-.938L12.339,1.313A1.5,1.5,0,0,1,13.51.75h5.219A.75.75,0,0,1,19.315,1.969Z']],
  ArrowCircleRight: ['arrow-circle-right', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 12.000 A11.250 11.250 0 1 0 23.250 12.000 A11.250 11.250 0 1 0 0.750 12.000 Z', 'M9,17.25l7.256-4.617a.751.751,0,0,0,0-1.266L9,6.75']],
  ArrowThickUp1: ['arrow-thick-up-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M1.97,10.205a.75.75,0,0,0,0,1.061l2.121,2.121a.75.75,0,0,0,1.061,0L9.8,8.743V22.5a.75.75,0,0,0,.75.75h3a.75.75,0,0,0,.75-.75V8.743l4.644,4.644a.75.75,0,0,0,1.061,0l2.121-2.121a.75.75,0,0,0,0-1.061L13.107,1.189a1.5,1.5,0,0,0-2.122,0Z']],
  ArrowThickRight: ['arrow-thick-right', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M1.5,7.75h9.75V4.008a.749.749,0,0,1,1.223-.587l10.5,8.242a.761.761,0,0,1,0,1.174l-10.5,8.242a.749.749,0,0,1-1.223-.587V16.75H1.5a.753.753,0,0,1-.75-.756V8.506A.753.753,0,0,1,1.5,7.75Z']],
  ArrowThickCircleRight1: ['arrow-thick-circle-right-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 12.000 A11.250 11.250 0 1 0 23.250 12.000 A11.250 11.250 0 1 0 0.750 12.000 Z', 'M5.25,13.5a.75.75,0,0,0,.75.75h6.75l-1.72,1.72a.749.749,0,0,0,0,1.06l1.19,1.19a.749.749,0,0,0,1.06,0l5.69-5.69a.749.749,0,0,0,0-1.06L13.28,5.78a.749.749,0,0,0-1.06,0L11.03,6.97a.749.749,0,0,0,0,1.06l1.72,1.72H6a.75.75,0,0,0-.75.75Z']],
  ArrowThickRight3: ['arrow-thick-right-3', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M10.757,4a.75.75,0,0,0-.53,1.28L14.947,10H1.5a.75.75,0,0,0-.75.75v3a.75.75,0,0,0,.75.75H14.947l-4.72,4.72a.75.75,0,0,0,.53,1.28h3.932a1.5,1.5,0,0,0,1.061-.439l7.28-7.281a.749.749,0,0,0,0-1.06L15.75,4.439A1.5,1.5,0,0,0,14.689,4Z']],
  ArrowButtonRight2: ['arrow-button-right-2', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M21.124,11.363,3.875,1.6a.75.75,0,0,0-1.125.637V21.763a.75.75,0,0,0,1.125.637l17.249-9.763A.729.729,0,0,0,21.124,11.363Z']],
  ArrowThickCircleBottomLeftCorner2: ['arrow-thick-circle-bottom-left-corner-2', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 12.000 A11.250 11.250 0 1 0 23.250 12.000 A11.250 11.250 0 1 0 0.750 12.000 Z', 'M16.826,7.174a2.249,2.249,0,0,0-3.182,0L9.932,10.886V9.3A1.591,1.591,0,0,0,8.341,7.7h0A1.591,1.591,0,0,0,6.75,9.3V16.5a.75.75,0,0,0,.75.75h7.205A1.591,1.591,0,0,0,16.3,15.659h0a1.591,1.591,0,0,0-1.591-1.591H13.114l3.712-3.712a2.249,2.249,0,0,0,0-3.182Z']],
  ArrowDoubleUp: ['arrow-double-up', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M11.75,7.222l-7.1,4.517A.751.751,0,0,1,3.5,11.106V6.545A1.5,1.5,0,0,1,4.2,5.28L10.945.985a1.5,1.5,0,0,1,1.61,0l6.75,4.3A1.5,1.5,0,0,1,20,6.545v4.561a.751.751,0,0,1-1.153.633Z', 'M11.75,18.616l-7.1,4.517A.751.751,0,0,1,3.5,22.5V17.94a1.5,1.5,0,0,1,.7-1.266l6.75-4.295a1.5,1.5,0,0,1,1.61,0l6.75,4.3A1.5,1.5,0,0,1,20,17.94V22.5a.751.751,0,0,1-1.153.633Z']],
  ArrowUp1: ['arrow-up-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M.75,17.189,11.47,6.47a.749.749,0,0,1,1.06,0L23.25,17.189']],
  ArrowThickCircleDown: ['arrow-thick-circle-down', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 12.000 A11.250 11.250 0 1 0 23.250 12.000 A11.250 11.250 0 1 0 0.750 12.000 Z', 'M11.414,18.018,6.975,12.469A.75.75,0,0,1,7.56,11.25H9.75V6a.75.75,0,0,1,.75-.75h3a.75.75,0,0,1,.75.75v5.25h2.19a.75.75,0,0,1,.585,1.219l-4.439,5.549A.751.751,0,0,1,11.414,18.018Z']],
  ArrowButtonUp1: ['arrow-button-up-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M.75,11.689,11.47.97a.749.749,0,0,1,1.06,0L23.25,11.689', 'M.75,22.939,11.47,12.22a.749.749,0,0,1,1.06,0L23.25,22.939']],
  ArrowRight1: ['arrow-right-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M5.5.75,16.22,11.47a.749.749,0,0,1,0,1.06L5.5,23.25']],
  ArrowThickLeftBottomCorner1: ['arrow-thick-left-bottom-corner-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M17.25,21a.75.75,0,0,0,.75-.75v-3a.75.75,0,0,0-.75-.75H10.682L20.41,6.772a.75.75,0,0,0,0-1.061L18.289,3.59a.75.75,0,0,0-1.061,0L7.5,13.318V6.75A.75.75,0,0,0,6.75,6h-3A.75.75,0,0,0,3,6.75V19.5A1.5,1.5,0,0,0,4.5,21Z']],
  ArrowThickRightBottomCorner1: ['arrow-thick-right-bottom-corner-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M20.63,6.5a.75.75,0,0,0-.75-.75h-3a.75.75,0,0,0-.75.75v6.568L6.4,3.34a.75.75,0,0,0-1.061,0L3.22,5.461a.75.75,0,0,0,0,1.061l9.728,9.728H6.38a.75.75,0,0,0-.75.75v3a.75.75,0,0,0,.75.75H19.13a1.5,1.5,0,0,0,1.5-1.5Z']],
  ArrowDotDown: ['arrow-dot-down', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5',
    transform: 'translate(0 24) rotate(-90)'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 0.750 L23.250 0.750 L23.250 23.250 L0.750 23.250 Z', 'M12.375,19.5A.375.375,0,1,1,12,19.125a.375.375,0,0,1,.375.375', 'M10.5,16.125a.375.375,0,1,1-.375-.375.375.375,0,0,1,.375.375', 'M10.5,12.375A.375.375,0,1,1,10.125,12a.375.375,0,0,1,.375.375', 'M6.75,12.375A.375.375,0,1,1,6.375,12a.375.375,0,0,1,.375.375', 'M14.25,16.125a.375.375,0,1,1-.375-.375.375.375,0,0,1,.375.375', 'M14.25,12.375A.375.375,0,1,1,13.875,12a.375.375,0,0,1,.375.375', 'M10.5,8.625a.375.375,0,1,1-.375-.375.375.375,0,0,1,.375.375', 'M14.25,8.625a.375.375,0,1,1-.375-.375.375.375,0,0,1,.375.375', 'M10.5,4.875a.375.375,0,1,1-.375-.375.375.375,0,0,1,.375.375', 'M14.25,4.875a.375.375,0,1,1-.375-.375.375.375,0,0,1,.375.375', 'M18,12.375A.375.375,0,1,1,17.625,12a.375.375,0,0,1,.375.375']],
  ArrowRectangleRight: ['arrow-rectangle-right', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5',
    transform: 'translate(24 0) rotate(90)'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 0.750 L23.250 0.750 L23.250 23.250 L0.750 23.250 Z', 'M9,6.75l5.989,4.658a.75.75,0,0,1,0,1.184L9,17.25']],
  ArrowDotRight: ['arrow-dot-right', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5',
    transform: 'translate(24 24) rotate(180)'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 0.750 L23.250 0.750 L23.250 23.250 L0.750 23.250 Z', 'M19.5,11.625a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375', 'M16.125,13.5a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375', 'M12.375,13.5a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375', 'M12.375,17.25a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375', 'M16.125,9.75a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375', 'M12.375,9.75a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375', 'M8.625,13.5a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375', 'M8.625,9.75a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375', 'M4.875,13.5a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375', 'M4.875,9.75a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375', 'M12.375,6A.375.375,0,1,1,12,6.375.375.375,0,0,1,12.375,6']],
  ArrowDoubleDown1: ['arrow-double-down-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M5.461,14.59,12,18.752l6.538-4.162c.667-.424,1.711-.08,1.711.565v2.411a1.372,1.372,0,0,1-.7,1.129L12.68,23.064a1.332,1.332,0,0,1-1.358,0L4.454,18.7a1.372,1.372,0,0,1-.7-1.129V15.155C3.75,14.51,4.794,14.166,5.461,14.59Z', 'M5.461,6.187,12,10.349l6.539-4.162c.667-.424,1.711-.08,1.711.564V8.522a1.371,1.371,0,0,1-.7,1.129l-6.867,4.37a1.337,1.337,0,0,1-1.358,0L4.454,9.651a1.371,1.371,0,0,1-.7-1.129V6.751C3.75,6.107,4.794,5.763,5.461,6.187Z', 'M4.5 0.75L12 6 19.5 0.75']],
  ArrowThickCircleBottomRightCorner2: ['arrow-thick-circle-bottom-right-corner-2', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 12.000 A11.250 11.250 0 1 0 23.250 12.000 A11.250 11.250 0 1 0 0.750 12.000 Z', 'M7.174,7.174a2.249,2.249,0,0,0,0,3.182l3.712,3.712H9.3A1.591,1.591,0,0,0,7.7,15.659h0A1.591,1.591,0,0,0,9.3,17.25H16.5a.75.75,0,0,0,.75-.75V9.3A1.591,1.591,0,0,0,15.659,7.7h0A1.591,1.591,0,0,0,14.068,9.3v1.591L10.356,7.174a2.249,2.249,0,0,0-3.182,0Z']],
  ArrowDown2: ['arrow-down-2', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M20.25,2.271v12.3a1.533,1.533,0,0,1-.439,1.076L12.53,23.027a.742.742,0,0,1-1.06,0L4.189,15.645a1.533,1.533,0,0,1-.439-1.076V2.271A1.511,1.511,0,0,1,5.25.75h13.5A1.511,1.511,0,0,1,20.25,2.271Z']],
  ArrowRectangleLeft: ['arrow-rectangle-left', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5',
    transform: 'translate(0 24) rotate(-90)'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 0.750 L23.250 0.750 L23.250 23.250 L0.750 23.250 Z', 'M15,17.25,9.011,12.592a.75.75,0,0,1,0-1.184L15,6.75']],
  ArrowRectangleUp2: ['arrow-rectangle-up-2', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5',
    transform: 'translate(24 24) rotate(180)'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 0.750 L23.250 0.750 L23.250 23.250 L0.750 23.250 Z', 'M17.351,17.063,12,12.9,6.649,17.063a.858.858,0,0,1-1.4-.564V12.082a1.436,1.436,0,0,1,.576-1.129l5.618-4.369a.924.924,0,0,1,1.112,0l5.618,4.369a1.436,1.436,0,0,1,.576,1.129V16.5A.858.858,0,0,1,17.351,17.063Z']],
  ArrowThickDotCornerDownLeft: ['arrow-thick-dot-corner-down-left', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M5.89,18.36a.375.375,0,1,0,0,.53.374.374,0,0,0,0-.53', 'M11.89,18.36a.375.375,0,1,0,0,.53.374.374,0,0,0,0-.53', 'M5.89,6.36a.375.375,0,1,0,0,.53.374.374,0,0,0,0-.53', 'M10.39,13.86a.375.375,0,1,0,0,.53.374.374,0,0,0,0-.53', 'M14.89,9.36a.375.375,0,1,0,0,.53.374.374,0,0,0,0-.53', 'M19.39,4.86a.375.375,0,1,0,0,.53.374.374,0,0,0,0-.53', 'M5.89,12.36a.375.375,0,1,0,0,.53.374.374,0,0,0,0-.53', 'M17.89,18.89a.375.375,0,1,0-.53,0,.374.374,0,0,0,.53,0']],
  ArrowDotRight1: ['arrow-dot-right-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M21.375,11.375A.375.375,0,1,1,21,11.75a.375.375,0,0,1,.375-.375', 'M18,13.25a.375.375,0,1,1-.375.375A.375.375,0,0,1,18,13.25', 'M14.25,13.25a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375', 'M11.25,17a.375.375,0,1,1-.375.375A.375.375,0,0,1,11.25,17', 'M11.25,20.75a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375', 'M15,17a.375.375,0,1,1-.375.375A.375.375,0,0,1,15,17', 'M18,9.5a.375.375,0,1,1-.375.375A.375.375,0,0,1,18,9.5', 'M14.25,9.5a.375.375,0,1,1-.375.375A.375.375,0,0,1,14.25,9.5', 'M10.5,13.25a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375', 'M10.5,9.5a.375.375,0,1,1-.375.375A.375.375,0,0,1,10.5,9.5', 'M6.75,13.25a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375', 'M6.75,9.5a.375.375,0,1,1-.375.375A.375.375,0,0,1,6.75,9.5', 'M3,13.25a.375.375,0,1,1-.375.375A.375.375,0,0,1,3,13.25', 'M3,9.5a.375.375,0,1,1-.375.375A.375.375,0,0,1,3,9.5', 'M11.25,5.75a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375', 'M11.25,2a.375.375,0,1,1-.375.375A.375.375,0,0,1,11.25,2', 'M15,5.75a.375.375,0,1,1-.375.375A.375.375,0,0,1,15,5.75']],
  ArrowThickLeft3: ['arrow-thick-left-3', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M13.243,3.75a.75.75,0,0,1,.53,1.28L9.053,9.75H22.5a.75.75,0,0,1,.75.75v3a.75.75,0,0,1-.75.75H9.053l4.72,4.72a.75.75,0,0,1-.53,1.28H9.311a1.5,1.5,0,0,1-1.061-.439L.97,12.53a.749.749,0,0,1,0-1.06L8.25,4.189A1.5,1.5,0,0,1,9.311,3.75Z']],
  ArrowCornerRight: ['arrow-corner-right', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M4 3.75L19.91 19.66', 'M4.91 19.66L19.91 19.66 19.91 4.66']],
  ArrowRight: ['arrow-right', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.75 12L23.25 12', 'M12.75 22.5L23.25 12 12.75 1.5']],
  ArrowDown1: ['arrow-down-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M23.25,7.311,12.53,18.03a.749.749,0,0,1-1.06,0L.75,7.311']],
  ArrowDotLeft1: ['arrow-dot-left-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M2.25,11.375a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375', 'M5.625,9.5a.375.375,0,1,1-.375.375A.375.375,0,0,1,5.625,9.5', 'M9.375,9.5A.375.375,0,1,1,9,9.875.375.375,0,0,1,9.375,9.5', 'M12.375,5.75A.375.375,0,1,1,12,6.125a.375.375,0,0,1,.375-.375', 'M12.375,2A.375.375,0,1,1,12,2.375.375.375,0,0,1,12.375,2', 'M8.625,5.75a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375', 'M5.625,13.25a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375', 'M9.375,13.25A.375.375,0,1,1,9,13.625a.375.375,0,0,1,.375-.375', 'M13.125,9.5a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375', 'M13.125,13.25a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375', 'M16.875,9.5a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375', 'M16.875,13.25a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375', 'M20.625,9.5a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375', 'M20.625,13.25a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375', 'M12.375,17a.375.375,0,1,1-.375.375A.375.375,0,0,1,12.375,17', 'M12.375,20.75a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375', 'M8.625,17a.375.375,0,1,1-.375.375A.375.375,0,0,1,8.625,17']],
  ArrowRectangleUp: ['arrow-rectangle-up', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 0.750 L23.250 0.750 L23.250 23.250 L0.750 23.250 Z', 'M6.75,15l4.658-5.989a.75.75,0,0,1,1.184,0L17.25,15']],
  ArrowRectangleDown: ['arrow-rectangle-down', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5',
    transform: 'translate(24 24) rotate(180)'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 0.750 L23.250 0.750 L23.250 23.250 L0.750 23.250 Z', 'M17.25,9l-4.658,5.989a.75.75,0,0,1-1.184,0L6.75,9']],
  ArrowDotLeft: ['arrow-dot-left', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 0.750 L23.250 0.750 L23.250 23.250 L0.750 23.250 Z', 'M4.5,11.625A.375.375,0,1,1,4.125,12a.375.375,0,0,1,.375-.375', 'M7.875,9.75a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375', 'M11.625,9.75a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375', 'M11.625,6a.375.375,0,1,1-.375.375A.375.375,0,0,1,11.625,6', 'M7.875,13.5a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375', 'M11.625,13.5a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375', 'M15.375,9.75a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375', 'M15.375,13.5a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375', 'M19.125,9.75a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375', 'M19.125,13.5a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375', 'M11.625,17.25a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375']],
  ArrowRight2: ['arrow-right-2', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M2.561,3.75H14.689a1.5,1.5,0,0,1,1.061.439l7.28,7.281a.749.749,0,0,1,0,1.06l-7.28,7.281a1.5,1.5,0,0,1-1.061.439H2.561a1.5,1.5,0,0,1-1.5-1.5V5.25A1.5,1.5,0,0,1,2.561,3.75Z']],
  ArrowUp2: ['arrow-up-2', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M3.75,21.729V9.431a1.533,1.533,0,0,1,.439-1.076L11.47.973a.742.742,0,0,1,1.06,0l7.281,7.382a1.533,1.533,0,0,1,.439,1.076v12.3a1.511,1.511,0,0,1-1.5,1.521H5.25A1.511,1.511,0,0,1,3.75,21.729Z']],
  ArrowThickDotRight: ['arrow-thick-dot-right', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M20.625,11.25a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375', 'M18,16.125a.375.375,0,1,1-.375-.375.375.375,0,0,1,.375.375', 'M14.625,3a.375.375,0,1,1-.375.375A.375.375,0,0,1,14.625,3', 'M14.625,11.25a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375', 'M8.625,11.25a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375', 'M2.625,11.25a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375', 'M17.625,6.75a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375', 'M14.625,19.5a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375']],
  ArrowThickDotDown: ['arrow-thick-dot-down', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M11.875,21.5a.375.375,0,1,1,.375-.375.375.375,0,0,1-.375.375', 'M7.375,18.5a.375.375,0,1,1,.375-.375.375.375,0,0,1-.375.375', 'M20.125,15.5a.375.375,0,1,1,.375-.375.375.375,0,0,1-.375.375', 'M11.875,15.5a.375.375,0,1,1,.375-.375.375.375,0,0,1-.375.375', 'M11.875,9.5a.375.375,0,1,1,.375-.375.375.375,0,0,1-.375.375', 'M11.875,3.5a.375.375,0,1,1,.375-.375.375.375,0,0,1-.375.375', 'M16.375,18.5a.375.375,0,1,1,.375-.375.375.375,0,0,1-.375.375', 'M3.625,15.5A.375.375,0,1,1,4,15.125a.375.375,0,0,1-.375.375']],
  ArrowDown: ['arrow-down', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M12 0.75L12 23.25', 'M1.5 12.75L12 23.25 22.5 12.75']]
};
exports["default"] = _default;